import { initializeApp } from "firebase/app";
//import { getApps } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, connectAuthEmulator } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.FIREBASE_APP_ID,
  measurementId: process.env.FIREBASE_MEASUREMENT_ID,
};

//if (!getApps()?.length) {
//	initializeApp(firebaseConfig);
//}
const app = initializeApp(firebaseConfig);
if (firebaseConfig.measurementId) {
  const analytics = getAnalytics(app);
}

export const auth = getAuth(app);
export const googleProvider  = new GoogleAuthProvider();
export const db = getFirestore(app);

if (process.env.FIREBASE_EMULATOR === "true") {
  if (!auth.emulatorConfig) {
    connectAuthEmulator(auth, "http://localhost:9099");
    console.log("Auth Emulator connected to localhost:9099");
  }
}
